"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DeviceService = void 0;
const Helper_1 = require("../common/Helper");
class DeviceService {
    constructor(configUserProvider) {
        this.config = configUserProvider.getConfig();
        this.userManager = configUserProvider.getUserManager();
    }
    /**
     * To get all devices information associated to the client, call **getDevicesInfo()**
     * Please refer to the api document https://docs.cidaas.com/docs/cidaas-iam/2a2feed70303c-get-device-by-user for more details.
     * @example
     * ```js
     * cidaasDeviceService.getDevicesInfo().then(function (resp) {
     *   // the response will give you devices informations.
     * }).catch(function(ex) {
     *   // your failure code here
     * });
     * ```
     */
    getDevicesInfo(access_token) {
        const _serviceURL = this.config.authority + "/device-srv/devices";
        if (access_token) {
            return Helper_1.Helper.createHttpPromise(undefined, _serviceURL, false, "GET", access_token);
        }
        return Helper_1.Helper.getAccessTokenFromUserStorage(this.userManager).then((accessToken) => {
            return Helper_1.Helper.createHttpPromise(undefined, _serviceURL, false, "GET", accessToken);
        });
    }
    /**
     * To delete device associated to the client, call **deleteDevice()**
     * Please refer to the api document https://docs.cidaas.com/docs/cidaas-iam/3d44ad903d6e8-logout-the-user-for-a-device for more details.
     * @example
     * ```js
     * const options = {
     *   device_id: 'id of device associated to the client.' // call **getDevicesInfo()** to get List of device ids and its details.
     * };
     * cidaasDeviceService.deleteDevice(options).then(function (resp) {
     *   // your success code
     * }).catch(function(ex) {
     *   // your failure code
     * });
     * ```
     */
    deleteDevice(options, access_token) {
        const _serviceURL = this.config.authority + "/device-srv/device/" + options.device_id;
        const payload = window.navigator.userAgent ? Object.assign(Object.assign({}, options), { userAgent: window.navigator.userAgent }) : undefined;
        if (access_token) {
            return Helper_1.Helper.createHttpPromise(payload, _serviceURL, false, "DELETE", access_token);
        }
        return Helper_1.Helper.getAccessTokenFromUserStorage(this.userManager).then((accessToken) => {
            return Helper_1.Helper.createHttpPromise(payload, _serviceURL, false, "DELETE", accessToken);
        });
    }
    /**
     * to generate device info, call **createDeviceInfo()**.
     * Please refer to the api document https://docs.cidaas.com/docs/cidaas-iam/9b5a892afaf0b-create-device-info for more details.
     * @example
     * ```js
     * cidaasDeviceService.createDeviceInfo().then(function (resp) {
     *   // your success code
     * }).catch(function(ex) {
     *   // your failure code
     * });
     * ```
     */
    createDeviceInfo() {
        const value = ('; ' + document.cookie).split(`; cidaas_dr=`).pop().split(';')[0];
        if (!value) {
            const options = {
                userAgent: window.navigator.userAgent
            };
            const serviceURL = this.config.authority + '/device-srv/deviceinfo';
            return Helper_1.Helper.createHttpPromise(options, serviceURL, false, 'POST');
        }
    }
}
exports.DeviceService = DeviceService;
